import React from 'react';

import {Tab, Tabs} from '@pb/kit-component-tabs-v2';

import {GROUP_TABS} from '../constants';

type Props = {
    currentTab: string,
    setCurrentTab: (tab: string) => void,
    membersCount: number,
};

export const GroupTabs = ({currentTab, setCurrentTab, membersCount}: Props) => {
    return (
        <Tabs value={currentTab} onChange={setCurrentTab} style={{width: '100%'}}>
            <Tab
                key={GROUP_TABS.SETTINGS.name}
                value={GROUP_TABS.SETTINGS.name}
                {...GROUP_TABS.SETTINGS}
            />
            <Tab
                key={GROUP_TABS.MEMBERS.name}
                value={GROUP_TABS.MEMBERS.name}
                caption={`${GROUP_TABS.MEMBERS.caption} (${membersCount})`}
            />
        </Tabs>
    );
};
